import vi from "@/common/translate/vi";
import en from "@/common/translate/en";

let i18nResource = {
	vi,
	en,
};

export default i18nResource;
